import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

import { ECoachingChatMatrixFeedbackModalFormField as EFormField } from "../types"

const resolver: ReturnType<typeof yupResolver> = yupResolver(
    yup.object().shape({
        [EFormField.Feedback]: yup.string().nullable().notRequired().max(1024)
    })
)

export { resolver as coachingChatMatrixFeedbackFormResolver }
